import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Space, Typography } from 'antd';
import { FC, useState } from 'react';

type Props = {
	open: boolean;
	onConfirm: (notes: string) => void;
	onCancel: () => void;
	loading?: boolean;
};

const CancelConfirmModal: FC<Props> = ({ open, onConfirm, onCancel, loading }) => {
	const [notes, setNotes] = useState('');

	const handleConfirm = () => {
		onConfirm(notes);
		setNotes('');
	};

	const handleCancel = () => {
		setNotes('');
		onCancel();
	};

	return (
		<Modal
			open={open}
			footer={null}
			closable={false}
			maskClosable={false}
			width={560}
		>
			<Space direction='vertical' style={{ width: '100%', textAlign: 'center' }} size={0}>
				<div style={{ marginBottom: 24 }}>
					<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M31.9557 0C49.6302 0 64 14.3698 64 32.0443C64 49.7188 49.6302 64 31.9557 64C14.2812 64 0 49.7188 0 32.0443C0 14.3698 14.2812 0 31.9557 0ZM31.5987 11.782C30.7047 12.8531 30.2591 14.1042 30.2591 15.4409C30.2591 16.512 30.6161 17.406 31.1531 18.0287C31.7786 18.6542 32.6698 19.0112 33.5638 19.0112C34.8148 19.0112 35.9745 18.4742 36.8656 17.4031C37.6682 16.4206 38.1167 14.9925 38.1167 13.4758C38.1167 12.5818 37.8482 11.7792 37.2227 11.1537C36.5971 10.5281 35.706 10.1711 34.812 10.1711C33.6523 10.1711 32.4898 10.7081 31.5987 11.7792V11.782ZM23.4755 30.2591L24.5466 31.4188C25.3492 30.5247 26.1547 29.8107 26.6888 29.3651C27.2258 29.0081 27.6714 28.8281 28.0284 28.8281C28.2969 28.8281 28.5654 28.9167 28.7424 29.0966C28.831 29.3651 28.9224 29.6336 28.9224 30.0792C28.9224 32.3099 28.6539 33.738 27.4943 39.0935C26.3346 44.449 25.7091 48.3763 25.7091 50.9641C25.7091 51.9466 25.8891 52.6607 26.2461 53.1063C26.5146 53.5518 27.0487 53.9089 27.7628 53.9089C28.9224 53.9089 30.619 53.0149 32.5841 51.4982C34.5492 49.8901 36.5114 47.6594 38.6536 44.8031L37.494 43.8206C36.7799 44.7146 36.0659 45.3373 35.5289 45.7857C34.9919 46.1427 34.5463 46.4998 34.1893 46.4998C33.9208 46.4998 33.6523 46.2313 33.4753 46.0542C33.3867 45.7857 33.2953 45.4287 33.2953 44.8945C33.2953 44.5375 33.3839 43.3779 33.7409 41.3242C34.0094 39.2706 33.9208 39.2706 34.4549 36.2373C34.5435 35.3432 34.812 34.0951 35.0805 32.5784C35.7945 28.0255 36.2401 25.2578 36.2401 24.3667C36.2401 23.5641 35.9716 22.85 35.7031 22.4016C35.3461 21.956 34.8091 21.7761 34.1865 21.7761C33.1154 21.7761 31.6872 22.5787 29.7221 24.0068C27.757 25.5235 25.7948 27.5771 23.4727 30.2563L23.4755 30.2591Z" fill="#1557BC" />
					</svg>
				</div>
				<Typography.Title level={4} style={{ marginBottom: 32 }}>
					Apakah Anda yakin untuk melakukan Cancel Application Data?
				</Typography.Title>
				<div style={{ textAlign: 'left', width: '100%', marginBottom: 8 }}>
					<Typography.Text strong>Notes</Typography.Text>
				</div>
				<Input.TextArea
					rows={4}
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					disabled={loading}
					style={{ marginBottom: 12 }}
				/>
				<div style={{ textAlign: 'left', width: '100%', marginBottom: 32 }}>
					<Space size={6} align='start'>
						<InfoCircleOutlined style={{ color: '#8c8c8c', fontSize: 14, marginTop: 2 }} />
						<Typography.Text type='secondary' style={{ fontSize: 13 }}>
							Jika pilih YA, sistem akan meneruskan notifikasi kepada FRM
						</Typography.Text>
					</Space>
				</div>
				<div style={{ display: 'flex', gap: 16, width: '100%' }}>
					<Button
						block
						size='large'
						onClick={handleCancel}
						disabled={loading}
						style={{ fontWeight: 600 }}
					>
						TIDAK
					</Button>
					<Button
						block
						size='large'
						type='primary'
						loading={loading}
						onClick={handleConfirm}
						style={{ fontWeight: 600 }}
					>
						YA
					</Button>
				</div>
			</Space>
		</Modal>
	);
};

export default CancelConfirmModal;
